import type { Person } from '../../eventsApi/persons/person'

export class RecurringBillEntity {
    recurringBillId: string
    companyId: string
    description: string
    createdAt: Date
    updatedAt: Date
    firstDueAt: Date
    intervalType: 'week' | 'month' | 'day'
    intervalRange: number
    value: number
    status: number
    creditDebit: 'credit' | 'debit'
    generationLastRunAt?: Date
    generationLastCreationAt?: Date
    generationAntecedenceDays: number
    personId?: string
    person?: Person
}
